var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.permitted)?_c('prompt',{attrs:{"header":"Assignment Saved to Templates","subtext":"Would you like to assign this now?","button1":_vm.button1,"button2":_vm.button2}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }